import { render } from "./TodoListItem.vue?vue&type=template&id=99caf56c&scoped=true"
import script from "./TodoListItem.vue?vue&type=script&lang=js"
export * from "./TodoListItem.vue?vue&type=script&lang=js"

import "./TodoListItem.vue?vue&type=style&index=0&id=99caf56c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99caf56c"]])

export default __exports__